import { render, staticRenderFns } from "./proxyLogin.vue?vue&type=template&id=11c58520&scoped=true&"
import script from "./proxyLogin.vue?vue&type=script&lang=js&"
export * from "./proxyLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c58520",
  null
  
)

export default component.exports